import * as React from 'react';
import { connect } from 'react-redux';
import I18nActions from './i18n_actions';
import * as agui from 'arm-gui/dist/controls';

import { Utils, NumberFormatter, DateFormatter, i18n } from 'arm-common';


class LocalizzazioneDetails extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[LocalizzazioneDetails.jsx] ';
        this.modificaClick = this.modificaClick.bind(this);
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.deleteLocalizzazione = this.deleteLocalizzazione.bind(this);
        this.state = {
            showConfirm: false
        }
    }

    modificaClick() {
        this.props.history.push({
            pathname: '/impostazioni/localizzazioneCreate', state: {
                id: this.props.location.state.id,
                modifica: true
            }
        })
    }

    showConfirmPanel() {
        // $("#modalConfirm").modal("show");
        this.setState({ showConfirm: !this.state.showConfirm })
    }


    deleteLocalizzazione() {
        this.props.deleteLocalizzazione();
        this.setState({ showConfirm: false });
        this.props.history.push({
            pathname: '/impostazioni/localizzazione'
        });

    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');
        //faccio la chiamata REST per recuperare i dettagli 
        console.log(this.componentName + '[ID] ' + this.props.location.state.id);
        this.props.getI18nDetails(this.props.location.state.id);
    }

    inputChangeHandler(e, index) {
        if (e !== null && e !== undefined) {
            let value = e.target.value;
            let id = e.target.id;
            this.props.handleChange(id, value);
        }
    }


    render() {
        console.log(this.componentName + 'render');
        return (
            <div className="card">
                <div className="card-header">
                    <h3>Dettaglio di I18n {this.props.location.state.id}</h3>
                </div>
                <div className="card-body">
                    <table className="table table-bordered table-hover table-striped " >
                        <thead>
                            <tr>
                                <td>{i18n('ARM_CORE_PRINT.SHARED.INDEX', 'Index')}</td>
                                <td>{i18n('ARM_CORE_PRINT.SHARED.LINGUA', 'Lingua')}</td>
                                <td>{i18n('ARM_CORE_PRINT.SHARED.DESCRIZIONE', 'Descrizione')}</td>
                                <td>{i18n('ARM_CORE_PRINT.SHARED.DATA_AGGIORNAMENTO', 'Data Aggiornamento')}</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.rows && this.props.rows.map(
                                    (item, index) =>
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.id ? item.id.lang : null}</td>
                                            <td>{item.descr}</td>
                                            <td>{DateFormatter.dataFormatter(item.dataAgg)}</td>
                                        </tr>
                                )
                            }
                        </tbody>
                    </table>

                </div>
                <div className="card-footer">
                    <div className="float-left">
                        <agui.aButton bs="primary" className="mr-3" icon="fas fa-edit" onClick={this.modificaClick}>{i18n('ARM_CORE_PRINT.SHARED.MODIFICA', 'Modifica')}</agui.aButton>
                        {/* <BtnDelete onClick={this.showConfirmPanel} ></BtnDelete> */}
                        <agui.aButton
                            askConfirm="Sei sicuro di eliminare il i18n ?"
                            bs="danger"
                            // className="mr-3"
                            icon="fas fa-trash-alt"
                            onClick={this.deleteLocalizzazione}>
                            {i18n('ARM_CORE_PRINT.SHARED.ELIMINA', 'Elimina')}
                        </agui.aButton>
                    </div>
                    <agui.aButton bs="secondary" className="float-right mr-2" href="#/impostazioni/localizzazione" >{i18n('ARM_CORE_PRINT.SHARED.TORNA_ALLA_LISTA', 'Torna alla lista')}</agui.aButton>
                </div>


                {/* <ConfirmModalDeleteV4
                    show={this.state.showConfirm}
                    deleteOnClick={this.deleteLocalizzazione}
                    onClose={this.showConfirmPanel} /> */}
                {/* <agui.ConfirmModalV4 key="modalConfirm"
                    show={this.state.showConfirm}
                    id="modalConfirm"
                    testo="Sei sicuro di eliminare il i18n ?"
                    titolo="Attenzione"
                    okFunction={this.deleteLocalizzazione} /> */}
            </div>
        );
    }
};




function mapStateToProps(state, ownProps) {
    return {
        rows: state.localizzazione.i18n.listApLang
    }
}


function mapDispatchToProps(dispatch) {
    return {
        getI18nDetails(id) {
            return dispatch(I18nActions.getI18nDetails(id));
        },
        deleteLocalizzazione() {
            return dispatch(I18nActions.deleteLocalizzazione());
        },

        handleChange(index, e) {
            return dispatch(I18nActions.handleChange(index, e))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LocalizzazioneDetails);



